import { render, staticRenderFns } from "./user_card_list.vue?vue&type=template&id=f6dc13f6&scoped=true&"
import script from "./user_card_list.vue?vue&type=script&lang=js&"
export * from "./user_card_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dc13f6",
  null
  
)

export default component.exports